export const APP_TOAST_EVENT = 'app-toast';

const VALID_SEVERITIES = new Set(['success', 'info', 'warning', 'error']);

const normalizeSeverity = (severity) => {
  if (VALID_SEVERITIES.has(severity)) return severity;
  return 'info';
};

export const triggerAppToast = ({ message, severity = 'info', autoHideDuration = 5000 } = {}) => {
  if (!message) return;

  const event = new CustomEvent(APP_TOAST_EVENT, {
    detail: {
      message,
      severity: normalizeSeverity(severity),
      autoHideDuration,
    },
  });

  window.dispatchEvent(event);
};

export const triggerErrorToast = (message, autoHideDuration = 5000) => {
  triggerAppToast({ message, severity: 'error', autoHideDuration });
};
